// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jo-0";
export var assigneeDetails = "_jo-1";
export var assigneeInfo = "_jo-2";
export var dropdownContainer = "_jo-4";
export var dropdownImage = "_jo-5";
export var editAssigneeInfo = "_jo-3";
export var editAssigneeModalContainer = "_jo-6";
export var hidden = "_jo-8";
export var input = "_jo-7";